export const RWA_SHARED_SERIES_ERC721_ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "name_",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "symbol_",
        "type": "string"
      },
      {
        "internalType": "address[]",
        "name": "initialMinters",
        "type": "address[]"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "MinterUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "burn",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "uri",
        "type": "string"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "minters",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "ownerOf",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "setMinter",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "tokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

export const RWA_SHARED_SERIES_ERC721_BYTECODE = "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";

export const RWA_SHARED_SERIES_ERC721_SOLIDITY_SOURCE = "// SPDX-License-Identifier: MIT\npragma solidity ^0.8.19;\n\ninterface IERC721Receiver {\n    function onERC721Received(\n        address operator,\n        address from,\n        uint256 tokenId,\n        bytes calldata data\n    ) external returns (bytes4);\n}\n\n/**\n * @title RwaSharedSeriesErc721\n * @notice Minimal ERC-721-style collection for RWA series with shared access:\n *         contract owner (typically admin deployer) and explicit `minters` — the same addresses may\n *         call both `mint` and `burn` (custodian / tokenizer operators). `setMinter` grants or revokes both.\n *         Matches legacy `mint(to, tokenId, uri)` entrypoint used by the Core Tokenizer stack.\n */\ncontract RwaSharedSeriesErc721 {\n    string public name;\n    string public symbol;\n    address public owner;\n\n    mapping(uint256 => address) internal _owners;\n    mapping(address => uint256) internal _balances;\n    mapping(uint256 => string) private _tokenUris;\n    mapping(address => bool) public minters;\n\n    event Transfer(address indexed from, address indexed to, uint256 indexed tokenId);\n    event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);\n    event MinterUpdated(address indexed account, bool allowed);\n\n    modifier onlyOwner() {\n        require(msg.sender == owner, \"Only owner\");\n        _;\n    }\n\n    constructor(string memory name_, string memory symbol_, address[] memory initialMinters) {\n        owner = msg.sender;\n        name = name_;\n        symbol = symbol_;\n        for (uint256 i = 0; i < initialMinters.length; i++) {\n            address a = initialMinters[i];\n            if (a != address(0)) {\n                minters[a] = true;\n                emit MinterUpdated(a, true);\n            }\n        }\n        emit OwnershipTransferred(address(0), msg.sender);\n    }\n\n    function transferOwnership(address newOwner) external onlyOwner {\n        require(newOwner != address(0), \"Zero owner\");\n        emit OwnershipTransferred(owner, newOwner);\n        owner = newOwner;\n    }\n\n    function setMinter(address account, bool allowed) external onlyOwner {\n        require(account != address(0), \"Zero minter\");\n        minters[account] = allowed;\n        emit MinterUpdated(account, allowed);\n    }\n\n    function balanceOf(address account) external view returns (uint256) {\n        require(account != address(0), \"Zero address\");\n        return _balances[account];\n    }\n\n    function ownerOf(uint256 tokenId) public view returns (address) {\n        address o = _owners[tokenId];\n        require(o != address(0), \"Token not minted\");\n        return o;\n    }\n\n    function tokenURI(uint256 tokenId) external view returns (string memory) {\n        require(_owners[tokenId] != address(0), \"Token not minted\");\n        return _tokenUris[tokenId];\n    }\n\n    function mint(address to, uint256 tokenId, string memory uri) external {\n        require(msg.sender == owner || minters[msg.sender], \"Not minter\");\n        require(to != address(0), \"Zero recipient\");\n        require(_owners[tokenId] == address(0), \"Token exists\");\n        _balances[to] += 1;\n        _owners[tokenId] = to;\n        _tokenUris[tokenId] = uri;\n        emit Transfer(address(0), to, tokenId);\n    }\n\n    /// @notice Burn a token. Same access as mint: owner or minters (shared catalog operators).\n    function burn(uint256 tokenId) external {\n        require(msg.sender == owner || minters[msg.sender], \"Not minter\");\n        address tokenOwner = _owners[tokenId];\n        require(tokenOwner != address(0), \"Token not minted\");\n        require(_balances[tokenOwner] > 0, \"Balance\");\n        _balances[tokenOwner] -= 1;\n        delete _owners[tokenId];\n        delete _tokenUris[tokenId];\n        emit Transfer(tokenOwner, address(0), tokenId);\n    }\n\n    function _transfer(address from, address to, uint256 tokenId) internal {\n        require(_owners[tokenId] == from, \"From not owner\");\n        require(to != address(0), \"Zero recipient\");\n        require(_balances[from] > 0, \"Balance\");\n        _balances[from] -= 1;\n        _balances[to] += 1;\n        _owners[tokenId] = to;\n        emit Transfer(from, to, tokenId);\n    }\n\n    /// @notice Holder-only transfer (no approvals). Sufficient for custody vault lock from the current owner wallet.\n    function transferFrom(address from, address to, uint256 tokenId) public {\n        require(from == ownerOf(tokenId), \"From not owner\");\n        require(msg.sender == from, \"Only token holder\");\n        _transfer(from, to, tokenId);\n    }\n\n    function safeTransferFrom(address from, address to, uint256 tokenId) public {\n        safeTransferFrom(from, to, tokenId, \"\");\n    }\n\n    function safeTransferFrom(address from, address to, uint256 tokenId, bytes memory data) public {\n        require(from == ownerOf(tokenId), \"From not owner\");\n        require(msg.sender == from, \"Only token holder\");\n        _transfer(from, to, tokenId);\n        if (to.code.length > 0) {\n            bytes4 retval = IERC721Receiver(to).onERC721Received(msg.sender, from, tokenId, data);\n            require(retval == IERC721Receiver.onERC721Received.selector, \"Receiver rejected\");\n        }\n    }\n}\n";

export const RWA_SHARED_SERIES_ERC721 = {
  contractName: "RwaSharedSeriesErc721",
  abi: RWA_SHARED_SERIES_ERC721_ABI,
  abiJson: JSON.stringify(RWA_SHARED_SERIES_ERC721_ABI),
  bytecode: RWA_SHARED_SERIES_ERC721_BYTECODE,
  mintFunctionName: "mint",
  soliditySource: RWA_SHARED_SERIES_ERC721_SOLIDITY_SOURCE,
  sourceFileName: "RwaSharedSeriesErc721.sol"
};
